module.exports = __webpack_public_path__ + "static/img/2.bbe8ad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/district/assets/image/home/2.png
// module id = 82Mp
// module chunks = 3